class window.SearchDocument
  constructor: ->
    @searchDocumentButton = $('.js-search-document-button')
    @searchDocumentResertButton = $('.js-search-resert-button')
    @searchDocumentWrapper = $('.documents-list-wrapper')
    @searchQuery = $('.js-document-search-query')
    @searchForm = $('#documentSearchForm')


    @initSearchDocuments()

  initSearchDocuments: ->
    self = this

    @searchForm.submit (event) ->
      event.preventDefault()
      dataInputs = self.searchForm.serialize()
      self.documentFormInProcessing(self);
      $.ajax
        url: $(this).attr('action') # Путь до скрипта поиска
        data: dataInputs
        type: 'get'
        dataType: 'html'
        success: (result) ->
          self.documentFormInProcessing(self);

          self.searchDocumentResertButton.toggleClass('search-resert-button--dissactive')

          self.searchDocumentWrapper.html($(result).find('.documents-list-wrapper__content'))

    @searchDocumentResertButton.click ->
      self.searchQuery.val('')
      $(this).toggleClass('search-resert-button--dissactive')
      self.documentFormInProcessing(self);
      $.ajax
        url: self.searchForm.attr('action') # Путь до скрипта поиска
        type: 'get'
        dataType: 'html'
        success: (result) ->
          self.documentFormInProcessing(self);
          self.searchDocumentWrapper.html($(result).find('.documents-list-wrapper__content'))

  documentFormInProcessing: (self)->
    if self.searchDocumentButton.attr('disable') == 'true'
      self.searchDocumentButton.removeAttr('disable')
    else
      self.searchDocumentButton.attr('disable', 'true')

    self.searchDocumentButton.toggleClass('processing')
    self.searchDocumentWrapper.toggleClass('processing')



// WEBPACK FOOTER //
// ./assets/javascripts/app/search_document.coffee